import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import { AdvertisingInvoiceDao } from '@/interfaces/advertising/AdvertisingInvoice.dao'
import { AdvertisingErrorsDao } from '@/interfaces/advertising/AdvertisingErrorsDao'
import { AdvertisingProfilesDao } from '@/interfaces/advertising/AdvertisingProfiles.dao'

export default class AdvertisingService extends ApiService {
    async getInvoice(
        invoiceId: string,
        params?: IRequestParameters,
    ): Promise<AdvertisingInvoiceDao | AdvertisingErrorsDao | null> {
        return this.request<undefined, AdvertisingInvoiceDao | AdvertisingErrorsDao | null>(
            'GET',
            `/advertising-invoices/${encodeURIComponent(invoiceId)}`,
            params,
            undefined,
            undefined,
            'getInvoice',
        ).catch(() => null)
    }
    async getProfiles(params?: IRequestParameters): Promise<AdvertisingProfilesDao | AdvertisingErrorsDao | null> {
        return this.request<undefined, AdvertisingProfilesDao | AdvertisingErrorsDao | null>(
            'GET',
            `/advertising-invoices/profiles`,
            params,
            undefined,
            undefined,
            'getProfiles',
        ).catch(() => null)
    }
}
